import { Injectable } from '@angular/core';

import { forkJoin, map, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SubscriptionService } from './subscription.service';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionResolver {
  constructor(private subscription: SubscriptionService, private session: SessionService) {
  }

  resolve(): Observable<any> {

    if (this.session.isAwaitingInitialSetup) {
      return of(null);
    }

    return forkJoin(this.subscription.getBilling(), this.subscription.getPlans()).pipe(
      map((reqs) => {
        return { billing: reqs[0], plans: reqs[1] };
      }),
      catchError((error) => {
        const fallback = { billing: null, plans: [] };
        return of(fallback);
      })
    );
  }
}
